var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page --error" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h1", [
          _vm._v(
            _vm._s(
              _vm.__(
                "It looks like your site didn't transfer.",
                "bluehost-site-migrator"
              )
            )
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.__(
                  "We might have gotten disconnected, or there could be something else going on. Let's figure it out.",
                  "bluehost-site-migrator"
                )
              ) +
              "\n\t\t"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.__("Call us at 888-401-4678", "bluehost-site-migrator")
              ) +
              "\n\t\t"
          ),
        ]),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "button",
            attrs: { to: "/compatible", tag: "button" },
          },
          [_vm._v(_vm._s(_vm.__("Try Again", "bluehost-site-migrator")))]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("img", { attrs: { src: _vm.imageSrc } }),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }